import {
    Component,
    ChangeDetectionStrategy,
    OnInit,
    ViewChild,
    ChangeDetectorRef,
    OnDestroy
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormHelperService } from '@classifieds-sell/shared';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { Subject } from 'rxjs';
import { FeeCalculationFacade } from '../../state/fee-calculation/fee-calculation.facade';
import { MotorsSectionBase } from '../motors-section-base';

@Component({
    selector: 'motors-classified-pricing-section',
    templateUrl: './motors-classified-pricing-section.component.html',
    styleUrls: ['./motors-classified-pricing-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MotorsClassifiedPricingSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('motorsClassifiedPricingSectionForm')
    motorsClassifiedPricingSectionForm: NgForm;

    constructor(
        public draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _formHelperService: FormHelperService,
        public _feeCalculationFacade: FeeCalculationFacade
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this._formHelperService.validate(this.motorsClassifiedPricingSectionForm);
        return this.motorsClassifiedPricingSectionForm.form.valid;
    }

    dirty(): boolean {
        return this.motorsClassifiedPricingSectionForm.form.dirty;
    }
}
